import { cor_segura, com_alfa }                                 from "@/utils/RpgFunction";

// Selo da patente (cor, emoji ou imagem, nome). Sem patente, nao mostra nada.
export default function PatenteBadge({ patente, className = "" }) {
  if (!patente?.nome) return null;
  const cor = cor_segura(patente.cor);

  return (
    <span
      title={`Patente: ${patente.nome}`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-rajdhani font-semibold text-foreground whitespace-nowrap ${className}`}
      style={{ borderColor: com_alfa(cor, 0.6), backgroundColor: com_alfa(cor, 0.18) }}
    >
      {patente.imagem ? (
        <img src={patente.imagem} alt="" className="w-4 h-4 object-contain" />
      ) : patente.icone ? (
        <span aria-hidden="true">{patente.icone}</span>
      ) : null}
      {patente.nome}
    </span>
  );
}
